<template lang="html">
  <div id="navigationBar">
    <transition name="fade">
      <img v-if="!$store.state.spinning" src="../../../assets/img/logo.png" class="kyushinjuku-logo">
    </transition>
      <spinner v-if="$store.state.spinning"
      :color="'white'" :size="'40px'" style="margin-top: 18px;"></spinner>
      <span v-touch:swipe.left="swipeHandler" >
        <label @click="open_Menu"><span><i v-if="!reschedulinglist" class="icon-menu menu_style"></i><i v-if="reschedulinglist" class="icon-exclamation-sign attention"></i> </span></label>
      <div id="nav-drawer">
          <input id="nav-input" type="checkbox" class="nav-unshown">
          <label class="nav-unshown" id="nav-close" for="nav-input"></label>
          <div id="nav-content">
            <ul class="menu">
              <h1 class="mune_title">Menu
                <span v-if="$store.state.userInfo.user_type !== 'student'" class="school" @click="schoolChange" v-on:click="close_Menu">
                  <a v-if="$store.state.userInfo.school_id === '1'" class="school_ike">池袋校</a>
                  <a v-if="$store.state.userInfo.school_id === '2'" class="school_yoko">横浜校</a>
                </span>
              </h1>
              <datepicker
                language="ja"
                :format="'yyyy年MM月dd日(D)'"
                :value="$store.state.curDate.toISOString()"
                :inline="true"
                :disabled="getDisableDays()"
                @selected="dateSelectHandler"
                :style="'float:right;'"
                @input="close_Menu"
                >
              </datepicker>
              <span v-on:click="close_Menu">
                <router-link tag="button" to="/SpTable" title="座席予約表を見る" class="menubutton">
                  <i class="icon-timeline"></i>
                  <span >座席予約表を見る</span>
                </router-link>
              </span>
              <span v-on:click="close_Menu">
                <router-link tag="button" to="/SpRescheduling" title="予約変更" class="menubutton" >
                  <i class="icon-alarm"></i>
                  <span>振替を依頼する</span>
                </router-link>
              </span>
              <span v-on:click="close_Menu">
                <router-link tag="button" to="/SpReschedulingList" title="依頼リスト" class="menubutton">
                  <i class="icon-list"></i>
                  <span>依頼リスト</span>
                  <i class="icon-exclamation-sign" style="color: red; font-size: 8vh;" v-if="reschedulinglist"></i>
                </router-link>
              </span>
              <span v-on:click="close_Menu">
                <router-link tag="button" to="/SpHelpPage" title="ヘルプ" class="menubutton">
                  <i class="icon-question-sign"></i>
                  <span class="explanationText">ヘルプ</span>
                </router-link>
              </span>
              <span v-on:click="close_Menu">
                <router-link tag="button" to="/Spuser" title="ユーザー情報" class="menubutton">
                  <i class="icon-user"></i>
                  <span>ユーザー情報</span>
                </router-link>
              </span>
              <button title="ログアウト" class="menubutton"
                @click="beforeLogout">
                <i class="icon-exit"></i>
                <span class="explanationText">ログアウト</span>
              </button>
              <span id="onlineCheckBox" class="onlineCheckBox">
                <input type="checkbox" id="showOnline" name="showOnline" @click="showOnline"/>
                <label for="showOnline">オンライン授業表示</label>
              </span>
            </ul>
          </div>
      </div>
      </span>
    <div id="bottomline">
    </div>
  </div>
</template>

<script>
import DatePicker from 'vuejs-datepicker'
import spinner from 'vue-loading-spinner/src/components/Pencil.vue'

import {
  TIMETABLE_CHANGE_DATE,
  CHANGE_SCHOOL,
  SHOW_ONLINE
} from '@/vuex/mutation_types'
import {
  mapActions,
  mapGetters
} from 'vuex'

export default {
  data () {
    return {
      hover: '',
      reschedulinglist: false
    }
  },
  components: {
    'datepicker': DatePicker,
    'spinner': spinner
  },
  computed: {
    ...mapGetters([
      'getCurDateFormated'
    ]),
    isAdmin () {
      if (this.$store.state.userInfo.user_type) {
        return this.$store.state.userInfo.user_type === 'admin'
      }
      return false
    }
  },
  mounted: function () {
    /* datepickerのカレンダーCSSの変更 */
    const target = document.getElementsByClassName('vdp-datepicker__calendar')
    for (var i = 0; i < target.length; i++) {
      target[i].style.width = '100%'
    }
    this.getReschedulingetList(this.$store.state.userInfo.user_id).then((res) => {
      if (res.data.length > 0) {
        this.reschedulinglist = true
      } else {
        this.reschedulinglist = false
      }
    })
  },
  methods: {
    ...mapActions([
      'getReservations',
      'getReschedulingetList',
      'getClassrooms'
    ]),
    swipeHandler () {
      this.close_Menu()
    },
    dateSelectHandler (payload) {
      this.$store.commit(TIMETABLE_CHANGE_DATE, {
        date: payload
      })
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated,
        school_id: this.$store.state.userInfo.school_id
      })
    },
    beforeLogout () {
      let isYes = confirm('ログアウトします．よろしいでしょうか．')
      if (isYes) {
        this.$router.push('/logout')
      }
    },
    getDisableDays () {
      let ddays = {
        days: [0]
      }
      if (this.$store.state.userInfo.is_Sunday_user === true) {
        return {days: []}
      } else {
        return ddays
      }
    },
    open_Menu () {
      document.getElementById('nav-input').checked = true
    },
    close_Menu () {
      this.getReschedulingetList(this.$store.state.userInfo.user_id).then((res) => {
        if (res.data.length > 0) {
          this.reschedulinglist = true
        } else {
          this.reschedulinglist = false
        }
      })
      document.getElementById('nav-input').checked = false
    },
    schoolChange () {
      if (this.$store.state.userInfo.school_id === '1') {
        this.$store.commit(CHANGE_SCHOOL, '2')
        this.getClassrooms(this.$store.state.userInfo.school_id)
        this.getReservations({
          all: 1,
          date: this.getCurDateFormated,
          school_id: this.$store.state.userInfo.school_id
        })
      } else {
        this.$store.commit(CHANGE_SCHOOL, '1')
        this.getClassrooms(this.$store.state.userInfo.school_id)
        this.getReservations({
          all: 1,
          date: this.getCurDateFormated,
          school_id: this.$store.state.userInfo.school_id
        })
      }
    },
    showOnline (event) {
      this.$store.commit(SHOW_ONLINE, event.target.checked)
      console.log(this.$store.state.showOnline)
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated,
        school_id: this.$store.state.userInfo.school_id
      })
    }
  }
}
</script>

<style lang="css" scoped>
div#navigationBar {
  position: fixed;  /* 画面上部に固定 */
  box-sizing: border-box;
  width: 100%;
  height: 80px;
  max-height: 80px;
  min-height: 30px;
  margin: 0;
  background-color: #ffd500;

  z-index: 9999;
}
.router-link-exact-active.currentLink {
  background-color: #0065B3;
  text-shadow: none;
}
.school {
  font-size: 10vw;
}
.school_ike {
  background-color: rgb(0, 101, 179);
  border-radius: 10px;
}
.school_yoko {
  background-color: rgb(0, 150, 33);
  border-radius: 10px;
}
#bottomline{
  display: block;
  position: absolute;
  width: 100%;
  float: none;
  border: none;
  padding: 0;
  top: 80px;
  height: 1px;
  border-top: solid 2px #E69200;
  background: none;
  border-bottom: none;
}

/* ロゴ用のCSS */
.kyushinjuku-logo {
  display: inline-block;
  background: white;
  height: 80px;
  shadow: #888 1px 1px 0px, #888 -1px 1px 0px,
              #888 1px -1px 0px, #888 -1px -1px 0px;
}
.fade-enter-active {
  transition: opacity .5s
}
.fade-leave-active {
  transition: opacity 0s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}

#nav-drawer {
  position: relative;
}

/*チェックボックス等は非表示に*/
.nav-unshown {
  display:none;
}

/*アイコンのスペース*/
#nav-open {
  position: fixed;
  top:10px;
  right: 4vw;
  width: 30px;
  height: 80px;
  vertical-align: middle;
}

/*ハンバーガーアイコンをCSSだけで表現*/
#nav-open span, #nav-open span:before, #nav-open span:after {
  right: 0;
}

/*閉じる用の薄黒カバー*/
#nav-close {
    display: none;/*はじめは隠しておく*/
    position: fixed;
    z-index: 99;
    top: 0;/*全体に広がるように*/
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0;
    transition: .3s ease-in-out;
}

/*中身*/
#nav-content {
    overflow: auto;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;/*最前面に*/
    width: 90%;/*右側に隙間を作る*/
    max-width: 90%;/*最大幅*/
    height: 100%;
    background: #fff;/*背景色*/
    transition: .3s ease-in-out;/*滑らかに表示*/
    -webkit-transform: translateX(-105%);
    transform: translateX(-105%);/*左に隠しておく*/
}

/*チェックが入ったらもろもろ表示*/
#nav-input:checked ~ #nav-close {
    display: block;/*カバーを表示*/
    opacity: .5;
}

#nav-input:checked ~ #nav-content {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);/*中身を表示*/
    box-shadow: 6px 0 25px rgba(0,0,0,.15);
}
.menu{
  float: left;
  width: 100%;
}
.mune_title{
  font-size: 50px;
  color: rgb(255, 255, 255);
  font-weight: bold;
  background-color: rgb(57, 66, 69);
}
.menubutton{
  width: 100%;
  height: 80px;
  font-size: 3vh;
  margin: 2px;
  background-color: rgb(183, 228, 254);
}
.x{
  width: 100%;
}
.attention{
  position: fixed;
  display: inline-block;
  font-size: 13vw;
  top: 1vh;
  right: 3vw;
  color: red;
}
.menu_style{
  display: inline-block;
  position: fixed;
  top: 10px;
  right: 10px;
  font-size: 50px;
}
</style>



// WEBPACK FOOTER //
// SpAppHeader.vue?6ee0924c